import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../ReusableComponents/title";
import "../../assets/css/accountmetrics.scss";
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import LineImg from "../../assets/images/GradianLong.svg";
import LoopIcon from "../../assets/images/loop.svg";
import AMDropdown from "../ReusableComponents/AMDropdown";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import BalanceChart from "../Charts/BalanceChart";
import ProfitChart from "../Charts/ProfitChart";
import DrawdownChart from "../Charts/DrawdownChart";
import { dollarUS, formatDate } from "../../utilities/formatters";
import {
  SetTradesData,
  fetchAccountObjectives,
  saveError,
} from "../../store/reducers/dashboardReducer";
import KabanBoard from "./KabanBoard";
import logoutReducer from "../../store/reducers/logout";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";

const NumFormatter = (num) => {
  const NumClass = num < 0 ? "Negative" : "Positive";

  return <div className={NumClass}>{Number(num).toFixed(2)}</div>;
};

const StatFormatter = (data) => {
  const Stat = data && data.toLowerCase();

  const classList =
    Stat === "success"
      ? "StatusPassed"
      : Stat === "failed"
      ? "StatusFailed"
      : "StatusInProgress";

  return <div className={`AMStat ${classList}`}>{data}</div>;
};

const ProgramObjectives = ({
  AccountInfo,
  Statistics,
  ProfitHistory,
  DailySummary,
  ProfitChartData,
  DrawDown,
  PerformanceChart,
  ProfitData,
  setRefreshData,
  refreshData,
}) => {
  const [value, setValue] = React.useState("1");
  const [Objectives, setObjectives] = React.useState(false);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  // kanban board data fetch

  const current_account = useSelector((state) => state.user.current_account);
  const idToken = useSelector((state) => state.ACCtoken);
  const dispatch = useDispatch();
  const fetchTradesData = async () => {
    try {
      // const payload = idToken;
      const { data, status } = await axiosInstance.get(
        `v2/account/datewise-histroy/${current_account}?platform=${AccountInfo.platform}`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          cacheControl: "no-cache",
          pragma: "no-cache",
        }
      );
      if (status === 401) {
        dispatch(logoutReducer());
        return;
      }
      dispatch(SetTradesData(data || []));
    } catch (error) {
      dispatch(saveError(error));
    }
  };
  useEffect(() => {
    fetchTradesData();
  }, [current_account, idToken]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const ProfitTargetObj = () => {
    if (Objectives) {
      return (
        <AMDropdown
          head={`Profit ${
            Objectives &&
            Objectives["profit_target"] &&
            dollarUS(Objectives["profit_target"]["target"])
          }`}
          desc={"Profit target"}
          result={
            Objectives &&
            Objectives["profit_target"] &&
            dollarUS(Objectives["profit_target"]["result"].toFixed(2))
          }
          status={
            Objectives &&
            Objectives["profit_target"] &&
            Objectives["profit_target"]["status"]
          }
        />
      );
    }

    return false;
  };

  useEffect(() => {
    return () => {
      setValue("1");
    };
  }, []);

  useEffect(() => {
    if (
      AccountInfo &&
      AccountInfo.daily_max_dd &&
      AccountInfo.challenge &&
      AccountInfo.challenge["Max_Daily_Loss"]
    ) {
      dispatch(
        fetchAccountObjectives(AccountInfo.login_id, AccountInfo.platform)
      )
        .then((data) => {
          setObjectives(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [AccountInfo, dispatch]);

  const user_profile = useSelector((state) => state.user);
  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setValue("1");
      }
    }
  }, [user_profile]);

  const [refreshTimer, setRefreshTimer] = useState(5);

  const handleRefreshData = (id) => {
    if (AccountInfo && AccountInfo.login_id) {
      dispatch(
        fetchAccountObjectives(AccountInfo.login_id, AccountInfo.platform)
      )
        .then((data) => {
          setObjectives(data);
          id && id.classList.remove("refreshIcon");
        })
        .catch((error) => {
          console.log(error);
          id && id.classList.remove("refreshIcon");
        });
    }
  };
  const handleRefreshDataClick = () => {
    const id = document.getElementById("refresh-icon");
    id.classList.add("refreshIcon");
    handleRefreshData(id);
  };

  useEffect(() => {
    let refresh;
    if (refreshTimer < 0) {
      setRefreshTimer(5);
      handleRefreshData();
    }
    if (refreshData) {
      refresh = setInterval(() => {
        setRefreshTimer((prev) => --prev);
      }, 1000);
    } else {
      setRefreshTimer(5);
    }

    return () => {
      clearInterval(refresh);
    };
  });
  const targetDate =
    Objectives &&
    Objectives["drawdown_result"]["max_daily_loss"]["reset_utc_time"];

  return (
    <div>
      <Grid container className="AMStatsBox AMStatsBar mbb-20">
        <div className="refresh-button">
          <div className="  neonButtonCard">
            {refreshData
              ? `Refreshing in 00:${
                  refreshTimer < 10 ? "0" + refreshTimer : refreshTimer
                }`
              : "Refresh Disabled"}
          </div>
          <div className="StatsHead">
            <input
              type="checkbox"
              id="auto-refresh"
              value={refreshData}
              onChange={() => setRefreshData((prev) => !prev)}
            />
            <label htmlFor="auto-refresh">Auto-refresh</label>
          </div>
        </div>
        <div className="StatsSubRefresh" onClick={handleRefreshDataClick}>
          <img src={LoopIcon} alt="loop" id="refresh-icon" />
          Refresh
        </div>
      </Grid>
      <Grid
        container
        className="AMStatsBox mbb-20 AMStatsBoxContainer"
        justifyContent={"space-between"}
        gap={"20px"}
        marginTop={{ xs: "-30px" }}
        xs={12}
      >
        <Grid item textAlign="center" md={true} xs={true}>
          <div className="StatsHead mbb-10">Start Date</div>
          <div className="StatsSub">
            {AccountInfo &&
            AccountInfo.start_date &&
            AccountInfo.status !== "Funded"
              ? formatDate(AccountInfo.start_date)
              : false}
          </div>
        </Grid>
        <Grid item textAlign="center" md={true} xs={true}>
          <div className="StatsHead mbb-10">End Date</div>
          <div className="StatsSub">
            {AccountInfo &&
            Object.keys(AccountInfo).length &&
            AccountInfo.expiry_date
              ? formatDate(AccountInfo.expiry_date)
              : "Unlimited"}
          </div>
        </Grid>
        <Grid item textAlign="center" md={true} xs={true}>
          <div className="StatsHead mbb-10">Account Size</div>
          <div className="StatsSub">
            {AccountInfo &&
            AccountInfo.challenge &&
            AccountInfo.challenge.account_balance
              ? dollarUS(AccountInfo.challenge.account_balance)
              : 0}
          </div>
        </Grid>
        <Grid item textAlign="center" md={true} xs={true}>
          <div className="StatsHead mbb-10">Equity</div>
          <div className="StatsSub">
            {AccountInfo && AccountInfo && AccountInfo.equity
              ? dollarUS(AccountInfo.equity)
              : 0}
          </div>
        </Grid>
        {/* <Grid item textAlign="center" md={2} xs={2}>
          <div className="StatsHead mbb-10">Stage</div>
          <div className="StatsSub">
            {StatFormatter(
              AccountInfo &&
                ((AccountInfo.is_competition && "Competition") ||
                  AccountInfo.status)
            )}
          </div>
        </Grid> */}
        <Grid item textAlign="center" md={true} xs={true}>
          <div className="StatsHead mbb-10">Status</div>
          <div className="StatsSub">
            {StatFormatter(AccountInfo && AccountInfo.progress)}
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="ProgramObjBox">
        <Grid item md={7} xs={12}>
          <Grid xs={12} md={12} container className="AMChartBox mbb-20">
            <Box
              className="ContainerTab"
              md={12}
              sx={{ width: "100%", height: "360px" }}
            >
              <TabContext value={value}>
                <Box
                  className="SubTab"
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    {/*<Tab
                      className="ContainertabName"
                      label="Growth"
                      value="1"
                />*/}
                    <Tab
                      className="ContainertabName"
                      label="Balance"
                      value="1"
                    />
                    <Tab
                      className="ContainertabName"
                      label="Profit"
                      value="2"
                    />
                    <Tab
                      className="ContainertabName"
                      label="Drawdown"
                      value="3"
                    />
                  </TabList>
                </Box>
                {/*<TabPanel className="ContainerTabpanel" value="1">
                  <GrowthChart />
                </TabPanel>*/}
                <TabPanel className="ContainerTabpanel" value="1">
                  <BalanceChart PerformanceChart={PerformanceChart} />
                </TabPanel>
                <TabPanel className="ContainerTabpanel" value="2">
                  <ProfitChart
                    data={ProfitHistory && ProfitHistory}
                    ProfitChartData={ProfitChartData && ProfitChartData}
                    ProfitData={ProfitData}
                  />
                </TabPanel>
                <TabPanel className="ContainerTabpanel" value="3">
                  <DrawdownChart DrawDown={DrawDown} />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>

          <Grid container className="StatsBox d-grid mbb-20">
            <Title six>Statistic</Title>
            <div>
              <Grid className="mtt-20 AMStatBox">
                <Grid
                  item
                  className="StatisticAM  mbb-20"
                  xs={6}
                  justifyContent="space-between"
                >
                  <HeadAndDesc
                    className="hover-chart-text"
                    HeadTitle="Equity"
                    SubTitle={
                      AccountInfo && AccountInfo.equity
                        ? dollarUS(AccountInfo.equity)
                        : "$0"
                    }
                  />
                  <HeadAndDesc
                    className="hover-chart-text"
                    HeadTitle="Balance"
                    SubTitle={
                      AccountInfo && AccountInfo.balance
                        ? dollarUS(AccountInfo.balance)
                        : "$0"
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="No. of trades"
                    SubTitle={(Statistics && Statistics.trades) || 0}
                  />
                  <HeadAndDesc
                    HeadTitle="Win rate"
                    SubTitle={
                      Statistics && Statistics.win_ratio
                        ? `${Statistics.win_ratio.toFixed(2)} %`
                        : "$0"
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Average Lots"
                    SubTitle={
                      Statistics && Statistics.avg_lots
                        ? Statistics.avg_lots.toFixed(2)
                        : 0
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Lots"
                    SubTitle={
                      Statistics && Statistics.lots
                        ? Statistics.lots.toFixed(2)
                        : 0
                    }
                  />
                </Grid>
                <Grid
                  item
                  className="StatisticAM  gapp-10 mbb-20"
                  xs={6}
                  justifyContent="space-between"
                >
                  <HeadAndDesc
                    HeadTitle="Largest profit"
                    SubTitle={
                      (Statistics && dollarUS(Statistics.highest)) || "$0"
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Average profit"
                    SubTitle={
                      Statistics && Statistics.average_profit
                        ? dollarUS(Number(Statistics.average_profit).toFixed(2))
                        : "$0"
                    }
                    SubTitleClass="DescPositive"
                  />
                  <HeadAndDesc
                    HeadTitle="Average loss"
                    SubTitle={
                      Statistics && Statistics.average_loss
                        ? dollarUS(Number(Statistics.average_loss).toFixed(2))
                        : "$0"
                    }
                    SubTitleClass="DescNegative"
                  />
                  <HeadAndDesc
                    HeadTitle="Average RRR"
                    SubTitle={
                      Statistics && Statistics["rrr "]
                        ? Number(Statistics["rrr "]).toFixed(2)
                        : 0
                    }
                  />
                  {/* <HeadAndDesc
                    HeadTitle="Martingale Status"
                    SubTitle={
                      Objectives
                        ? StatFormatter(
                            String(Objectives.martingale.status).toLowerCase()
                          )
                        : false
                    }
                  /> */}
                  {/* <HeadAndDesc
                    HeadTitle="Martingale Count"
                    SubTitle={
                      Objectives
                        ? Objectives.martingale.martingale_count
                        : false
                    }
                  /> */}
                  {/* <HeadAndDesc
                    HeadTitle=""
                    SubTitle={
                      DailySummary && DailySummary["Expectancy Ratio"]
                        ? Number(DailySummary["Expectancy Ratio"])
                            .toFixed(2)
                            .split("-")
                            .join("")
                        : false
                    }
                  />
                  <HeadAndDesc HeadTitle="" SubTitle={""} />
                  <HeadAndDesc HeadTitle="" SubTitle="" /> */}
                </Grid>
                {/* <img src={LineImg} alt="" /> */}
                <Grid className="mtt-20 StatsTime" alignItems={"center"}>
                  {/*<HeadAndDesc
                    HeadTitle="Timezone :"
                    SubTitle="GMT+0"
                    HeadAndSubClassName="d-flex"
                  />*/}
                  <HeadAndDesc
                    width="100%"
                    HeadTitle="Timezone :"
                    SubTitle={String(new Date()).split(" ")[5]}
                    HeadAndSubClassName="Timezone"
                  />
                  <HeadAndDesc
                    width="100%"
                    HeadTitle="Last Updated :"
                    SubTitle={String(new Date()).split("GMT")[0].trim()}
                    HeadAndSubClassName="d-flex lastUpdated"
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid item md={5} xs={12}>
          <Grid container className="DailySummeryBox d-block mbb-20">
            <Title six>Daily Summary</Title>
            <Grid className="mtt-20 d-flex" flexWrap={"nowrap"}>
              <Grid item xs={12} className="d-grid gapp-10">
                <HeadAndDesc
                  HeadTitle="Gain"
                  SubTitle={
                    Statistics &&
                    Statistics.profit &&
                    NumFormatter(Statistics.profit)
                  }

                  // SubTitleClass="DescPositive"
                />
                {/* <HeadAndDesc
                  HeadTitle="Daily"
                  // SubTitle={
                  //   Statistics && Statistics.daily_gain
                  //     ? Statistics.daily_gain
                  //       .reduce((a, b) => a + b, 0)
                  //       .toFixed(2)
                  //     : false
                  // }
                  SubTitle={
                    Statistics &&
                    Statistics.profit &&
                    Statistics.daily_gain.toFixed(2)
                  }
                /> */}
                <HeadAndDesc
                  HeadTitle="Leverage"
                  SubTitle={
                    AccountInfo &&
                    AccountInfo.challenge &&
                    AccountInfo.challenge.Leverage
                      ? AccountInfo.challenge.Leverage
                      : false
                  }
                />
                <HeadAndDesc
                  HeadTitle="Abs Gain"
                  // SubTitle={
                  //   Statistics && Statistics.absolute_gain
                  //   && (Number(Statistics.absolute_gain)).toFixed(2)
                  // }
                  SubTitle={
                    Statistics &&
                    Statistics.absolute_gain &&
                    NumFormatter(Number(Statistics.absolute_gain).toFixed(2))
                  }
                  // SubTitleClass="DescPositive"
                />
                <HeadAndDesc
                  HeadTitle="Monthly"
                  SubTitle={
                    Statistics && Number(Statistics.monthly_gain).toFixed(2)
                  }
                />
                <HeadAndDesc
                  HeadTitle="Drawdown"
                  SubTitle={
                    Statistics && Number(Statistics.draw_down).toFixed(2)
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container className="TradingObjBox d-grid mbb-20">
            <Title six>Trading Objective</Title>
            <Grid
              className="TOBox mtt-20"
              gap="20px"
              display="flex"
              flexDirection="column"
            >
              {AccountInfo && AccountInfo.status === "Funded" ? (
                <AMDropdown
                  head={`Withdrawal Dates`}
                  desc={"Withdrawal dates"}
                  result={false}
                  status={
                    Objectives &&
                    Objectives["payout_dates"] &&
                    `${Objectives.payout_dates[0]} & ${Objectives.payout_dates[1]}`
                  }
                />
              ) : Objectives ? (
                <AMDropdown
                  head={`Minimum days - ${
                    Objectives && Objectives["trading_days"]
                      ? Objectives["trading_days"]["target"]
                      : ""
                  }`}
                  desc={"Minimum trading days"}
                  result={
                    Objectives && Objectives["trading_days"]
                      ? Objectives["trading_days"]["result"]
                      : ""
                  }
                  status={
                    Objectives && Objectives["trading_days"]
                      ? Objectives["trading_days"]["status"]
                      : ""
                  }
                />
              ) : (
                false
              )}
              <ProfitTargetObj />
              {Objectives ? (
                <React.Fragment>
                  <AMDropdown
                    head={`Max Loss ${
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      dollarUS(
                        Objectives["drawdown_result"]["max_loss"]["target"]
                      )
                    }`}
                    desc={"Max Loss"}
                    result={
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      dollarUS(
                        Objectives["drawdown_result"]["max_loss"][
                          "result"
                        ].toFixed(2)
                      )
                    }
                    status={
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      Objectives["drawdown_result"]["max_loss"]["status"]
                    }
                  />
                  <AMDropdown
                    targetValue={
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      dollarUS(
                        Objectives["drawdown_result"]["max_daily_loss"][
                          "target"
                        ]
                      )
                    }
                    head={`Max Daily Loss ${
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      dollarUS(
                        Objectives["drawdown_result"]["max_daily_loss"][
                          "target"
                        ]
                      )
                    }`}
                    desc={"Max Daily Loss"}
                    result={
                      Objectives &&
                      Objectives["drawdown_result"] &&
                      dollarUS(
                        Objectives["drawdown_result"]["max_daily_loss"][
                          "result"
                        ].toFixed(2)
                      )
                    }
                    status={
                      Objectives &&
                      Objectives["drawdown_result"]["max_daily_loss"]["status"]
                    }
                    remaining={
                      Objectives &&
                      String(
                        Objectives["drawdown_result"]["max_daily_loss"][
                          "status"
                        ]
                      ).toLowerCase() === "failed"
                        ? false
                        : Number(
                            Objectives["drawdown_result"]["max_daily_loss"][
                              "remaining"
                            ]
                          ).toFixed(2)
                    }
                    targetDate={targetDate}
                  />
                </React.Fragment>
              ) : (
                false
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <KabanBoard />
    </div>
  );
};

export default ProgramObjectives;
